export default __webpack_public_path__ + "static/media/EM1480.34I-38128_-26494_0.0eef34bb.jpg";